import { GoogleLogo } from "@phosphor-icons/react";
import PageShell from "@/components/PageShell";
import GoogleReviews from "@/components/GoogleReviews";
import { SITE } from "@/seoData";

const GOOGLE_REVIEW_URL = "https://search.google.com/local/writereview?placeid=ChIJx8Eov0VYD6wRPjfrK_i3LIE";

export default function Reviews() {
  const canonical = `${SITE}/reviews`;
  const seo = {
    title: "CleanOut247 Reviews | Junk Removal San Diego Customer Reviews",
    description: "Read Google reviews from CleanOut247 junk removal customers in 4S Ranch, Rancho Bernardo, Poway and across San Diego County — and leave your own.",
    canonical,
    jsonLd: [
      { "@context": "https://schema.org", "@type": "WebPage", name: "CleanOut247 Customer Reviews", url: canonical, about: { "@id": SITE + "/#business" } },
      { "@context": "https://schema.org", "@type": "BreadcrumbList", itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: SITE + "/" },
        { "@type": "ListItem", position: 2, name: "Reviews", item: canonical },
      ] },
    ],
  };
  return (
    <PageShell seo={seo} eyebrow="Reviews" h1="CleanOut247 Customer Reviews"
      lead="What homeowners, property managers and businesses across San Diego County say about our junk removal service on Google.">
      <GoogleReviews />
      <section className="px-5 lg:px-8 pb-16">
        <div className="max-w-5xl mx-auto">
          <a href={GOOGLE_REVIEW_URL} target="_blank" rel="noreferrer" data-testid="reviews-review-on-google"
            className="inline-flex items-center gap-2 bg-[#15306E] hover:bg-[#0B1E45] text-white font-display font-bold uppercase tracking-wide px-6 py-3.5 rounded-sm transition-colors">
            <GoogleLogo size={18} weight="bold" /> Review us on Google
          </a>
        </div>
      </section>
    </PageShell>
  );
}
